import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

export const streetViewSelector = (state: AppState) => state.frontendState.mapTools.streetView;
export const useStreetViewSelector = () => useSelector(streetViewSelector);
